<template>
    <div class="mask" v-if="dataVal.flag" @click.stop="handleRefund">
        <div class="mask-content" @click.stop>
            <div class="mask-content-header">
                <img src="@/assets/images/icon/item_nav.png" alt="" srcset="">
                <div>修改密码</div>
            </div>
            <div class="mask-content-body">
                <div class="cont_search_item">
                    <div class="cont_search_item_l xin">原密码</div>
                    <div class="cont_search_item_r">
                        <el-input v-model="fromData.oldpwd" placeholder="请输入原密码"></el-input>
                    </div>
                </div>
                <div class="cont_search_item">
                    <div class="cont_search_item_l xin">密码</div>
                    <div class="cont_search_item_r">
                        <el-input v-model="fromData.newpwd" placeholder="请输入密码"></el-input>
                    </div>
                </div>
                <div class="cont_search_item">
                    <div class="cont_search_item_l xin">确认密码</div>
                    <div class="cont_search_item_r">
                        <el-input v-model="reppassword" placeholder="请输入确认密码"></el-input>
                    </div>
                </div>
                <div class="cont_search_empty"></div>
                <div class="cont_search_item cont_search_item2">
                    <div class="cont_search_item_l"></div>
                    <div class="cont_search_item_r">
                        <div class="cont_cen_item_cen_group">
                            <div class="cont_cen_item_cen_group_act" @click="handleSubmit">保存</div>
                            <div @click="handleReset">重置</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            reppassword: '',

            fromData: {
                oldpwd: '',
                newpwd: ''
            }
        };
    },
    mounted() {
    },
    methods: {
        handleReset() {
            this.reppassword = ''

            this.fromData = {
                oldpwd: '',
                newpwd: ''
            }
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: false,//是否调用接口
            }
            this.$emit("passwordCall", data);
        },
        handleSubmit() {
            if (this.fromData.newpwd != this.reppassword) {
                this.$message.error('新密码与确认密码不一致！');
                return false
            }
            let data = {
                flag: false,//弹窗是否显示
                submitFlag: true,//是否调用接口
                data: this.fromData
            }
            this.$emit("passwordCall", data);
        },
    },
    watch: {
        dataVal: {
            handler(val) {
                this.handleReset()
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 576px;
        border-radius: 4px;
        box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.2);
        background: #FFF;
        position: fixed;

        .mask-content-header {
            width: 100%;
            height: 60px;
            background-color: #ecf0f6;
            display: flex;
            align-items: center;
            padding-left: 31px;

            img {
                width: 23px;
                height: 24px;
            }

            div {
                font-size: 18px;
                color: #000000;
                margin-left: 10px;
            }
        }

        .mask-content-body {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 40px 0 35px;
            margin-top: 10px;

            .cont_search_item {
                width: 100%;
                display: flex;
                align-items: center;
                margin-top: 14px;

                .cont_search_item_l {
                    width: 80px;
                    font-size: 14px;
                    color: #000;
                    text-align: right;
                    padding-right: 10px;
                }

                .xin {
                    &::before {
                        content: '*';
                        color: #f56c6c;
                        margin-right: 4px;
                    }
                }

                /deep/ .cont_search_item_r {
                    flex: 1;
                    height: 32px;
                    background-color: #ffffff;
                    border-radius: 4px;
                    border: solid 1px #dbdbdb;

                    .el-input {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;

                        .el-input__inner {
                            width: 100%;
                            height: 100%;
                            border: 0;
                        }
                    }

                    .el-select {
                        width: 100%;
                        height: 100%;

                        .el-input__suffix {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .el-select__tags {
                        flex-wrap: nowrap;
                        overflow-y: auto;

                        &::-webkit-scrollbar {
                            height: 8px;
                        }

                        &::-webkit-scrollbar-thumb {
                            background: #dcdcdc;
                            border-radius: 2px;
                        }

                        &::-webkit-scrollbar-thumb:hover {
                            background: #c12e30;
                        }
                    }

                    .el-date-editor {
                        width: 100%;
                        height: 100%;

                        .el-range__icon,
                        .el-range__close-icon {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .el-range-separator {
                            height: auto;
                            line-height: auto;
                        }
                    }
                }
            }

            .cont_search_item2 {
                margin-top: 0;
                margin-bottom: 32px;

                .cont_search_item_r {
                    height: auto;
                    border: 0;
                    padding-left: 83px;
                }
            }

            .cont_cen_item_cen_group {
                display: flex;
                align-items: center;
                margin-top: 38px;

                div {
                    width: 86px;
                    height: 32px;
                    font-size: 12px;
                    color: #666666;
                    background-color: #ffffff;
                    border-radius: 4px;
                    border: solid 1px #dbdbdb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                .cont_cen_item_cen_group_act {
                    border: 0;
                    color: #ffffff;
                    background-color: #108ee9;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>